'use strict';

import React, { useState } from 'react';
import { doLogin } from 'utils/network/ServiceHelper';
import Notification from 'components/Notification';
import Loading from 'components/Loading';
import SSOService from 'utils/network/sso/sso.service';

export default function Login() {
  const [form, setForm] = useState({
    username: '',
    password: ''
  });
  const [notification, setNotification] = useState({
    show: false,
    error: false,
    title: '',
    message: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  function handleChangeForm(e) {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  }

  function closeNotification() {
    setNotification({ ...notification, show: false });
  }

  function isValidForm() {
    return form.username.length > 0 && form.password.length > 0;
  }

  function notif(title, message, isError = false, duration = 3000) {
    setNotification({
      show: true,
      title: title,
      message: message,
      error: isError
    });

    setTimeout(() => {
      setNotification({ ...notification, show: false });
    }, duration);
  }

  function togglePassword() {
    setShowPassword(!showPassword);
  }

  async function handleLogin(e) {
    if (!isValidForm()) {
      notif('Error', 'Please fill all required field!', true);
      return;
    }

    if (loading) {
      return;
    }

    e.preventDefault();
    setLoading(true);
    const baseUrl = process.env.REACT_APP_BASE_URL;

    try {
      const res = await doLogin(baseUrl, form);
      setLoading(false);

      if (res?.data?.message === 'Login berhasil') {
        const { access_token } = res.data;
        localStorage.setItem('token', access_token);
        localStorage.setItem('is_login', true);
        location.href = '/master-tier';
        return;
      }

      const err = JSON.parse(await res.text());
      if (err) {
        notif('Error', err.message, true);
        return;
      }

      notif('Error', 'Network error. Please try again later!', true);
    } catch (error) {
      setLoading(false);
      notif('Error', 'Network error. Please try again later!', true);
    }
  }

  return (
    <>
      <div className="flex items-center min-h-screen p-6 bg-gray-50 dark:bg-gray-900">
        <div className="flex-1 h-full max-w-xl mx-auto overflow-hidden bg-white rounded-lg shadow-xl dark:bg-gray-800">
          <div className="flex flex-col overflow-y-auto md:flex-row">
            <div className="flex items-center justify-center flex-1 p-6 sm:p-12">
              <div className="w-full">
                <h1 className="mb-4 text-xl font-semibold text-gray-700 dark:text-gray-200">
                  Login
                </h1>
                <form onSubmit={handleLogin}>
                  <label className="block text-sm">
                    <span className="text-gray-700 dark:text-gray-400">
                      Username
                    </span>
                    <input
                      className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 border-secondary focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                      placeholder="JaneDoed"
                      name="username"
                      value={form.email}
                      onChange={handleChangeForm}
                    />
                  </label>
                  <label className="block mt-4 text-sm">
                    <span className="text-gray-700 dark:text-gray-400">
                      Password
                    </span>
                    <div className="relative">
                      <input
                        className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 border-secondary focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                        placeholder="***************"
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        onChange={handleChangeForm}
                        value={form.password}
                      />
                      <div
                        className="absolute top-0 bottom-0 flex flex-col justify-center cursor-pointer right-2"
                        onClick={togglePassword}
                      >
                        {showPassword ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-6 h-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-6 h-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                            />
                          </svg>
                        )}
                      </div>
                    </div>
                  </label>
                  <button
                    type="submit"
                    className="flex flex-row items-center justify-center block w-full px-4 py-2 mt-4 text-sm font-medium text-center text-white border border-transparent rounded-lg leading-5 transition-colors duration-150 bg-main bg-secondary hover:bg-yellow-700 focus:outline-none"
                  >
                    {loading ? <Loading /> : null} Log in
                  </button>
                </form>
                <button
                  onClick={SSOService.authSso}
                  className="flex flex-row items-center justify-center  w-full px-4 py-2 mt-4 text-sm font-medium text-center text-white border border-transparent rounded-lg leading-5 transition-colors duration-150  bg-blue-500 hover:bg-blue-700 focus:outline-none"
                >
                  Log in With SSO
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Notification
        notification={notification}
        closeNotification={closeNotification}
      />
    </>
  );
}
